<template>
  <el-form
    ref="form"
    style="max-width: 500px;"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    :label-width="labelWidth"
    :disabled="formDisabled"
  >
    <template v-for="field in formFields">
      <!-- 文本输入框 -->
      <template v-if="field.type === 'INPUT' && (field.hidden !== true)">
        <div v-if="field.render" v-html="field.render">{{field.render}}</div>
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop" style="position: relative" >
          <el-input
            :type="field.inputType || 'text'"
            :disabled="!!field.disabled"
            v-model="form[field.prop]"
            :placeholder="field.placeholder || `${$t('common.pleaseInput')}${field.label}`"
            @change="(val) => (field.changeHandler || nothing)(val)"
            @ended="(val) => (field.changeHandler || nothing)(val)"
          >
          </el-input>
          <div v-if="field.help"
               style="position: absolute;top: 0;left: 105%;width: 100%;color: #00ff00;">
            {{field.help}}
          </div>
        </el-form-item>
      </template>

      <template v-else-if="field.type === 'NUMBER' && (field.hidden !== true)">
        <div v-if="field.render" v-html="field.render">{{field.render}}</div>
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <el-input-number
            :disabled="!!field.disabled"
            controls-position="right"
            :min="field.min === undefined ? -Infinity : field.min"
            :max="field.max === undefined ? Infinity : field.max"
            v-model="form[field.prop]"
            :placeholder="field.placeholder || `${$t('common.pleaseInput')}${field.label}`"
            @change="(val) => (field.changeHandler || nothing)(val)"
            style="width: 100%;"
          >
          </el-input-number> {{ field.unit }}
        </el-form-item>
      </template>

      <template v-else-if="field.type === 'CHECK' && (field.hidden !== true)">
        <el-form-item :prop="field.prop" :key="field.prop">
          <el-checkbox
            :disabled="!!field.disabled"
            v-model="form[field.prop]"
            @change="(val) => (field.changeHandler || nothing)(val)"
          >
          {{ field.label }}
          </el-checkbox>
        </el-form-item>
      </template>

      <!-- switch -->
      <template v-else-if="field.type === 'SWITCH' && (field.hidden !== true)">
        <el-form-item  :label="field.label" :prop="field.prop" :key="field.prop">
          <el-switch
            v-model="form[field.prop]"
            active-color="#13ce66"
            :disabled="!!field.disabled"
            @change="(val) => (field.changeHandler || nothing)(val)"
          >
          </el-switch>
        </el-form-item>
      </template>

      <!-- 多选 -->
      <template v-else-if="field.type === 'MILT_CHECK' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <el-checkbox-group
            v-model="form[field.prop]"
            :disabled="!!field.disabled"
            @change="(val) => (field.changeHandler || nothing)(val)"
          >
            <el-checkbox
              v-for="item in field.options"
              :label="item.value"
              :key="item.value"
              :disabled="item.disabled"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </template>

      <!-- 下拉选择框 -->
      <template v-else-if="field.type === 'SELECT' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <el-select v-model="form[field.prop]"
            filterable
            :multiple="!!field.multiple"
            :disabled="!!field.disabled"
            :placeholder="field.placeholder || `${$t('common.pleaseSelect')}${field.label}`"
            @change="(val) => (field.changeHandler || nothing)(val)"
            style="width: 100%;"
          >
            <el-option
              v-for="item in field.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>

      <template v-else-if="field.type === 'SELECT2' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
<!--          <el-select v-model="form[field.prop]"-->
<!--                     filterable-->
<!--                     :multiple="!!field.multiple"-->
<!--                     :disabled="!!field.disabled"-->
<!--                     :placeholder="field.placeholder || `${$t('common.pleaseSelect')}${field.label}`"-->
<!--                     @change="(val) => (field.changeHandler || nothing)(val)"-->
<!--                     style="width: 100%;"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in field.options"-->
<!--              :key="item.value"-->
<!--              :label="item.label"-->
<!--              :value="item.value"-->
<!--              :disabled="item.disabled"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
          <el-select
            v-model="form[field.prop]" clearable placeholder="请选择"
            @change="(val) => (field.changeHandler || nothing)(val)"
            style="width: 100%;" ref='selectUpResId'>
            <el-option hidden :onload="loadupResName(form[field.prop], field.options)" :key="field.prop" :value='form[field.prop]' :label='upResName'>
            </el-option>
            <el-tree
              :data='field.options'
              :props='field.defaultProps'
            :expand-on-click-node='false'
            :check-on-click-node='true'
            @node-click='handleNodeClick'
            >
            </el-tree>
          </el-select>
        </el-form-item>
      </template>

      <!-- 图片上传 -->
      <template v-else-if="field.type === 'IMAGE_UPLOAD' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <image-upload
            :url="form[field.prop]"
            :upload-scope="field.uploadScope"
            :upload-limit="field.uploadLimit"
            @uploadSuccess="(url) => {form[field.prop] = url}"
            :options="field.options"
          >
          </image-upload>
        </el-form-item>
      </template>

      <!-- 经纬度 -->
      <template v-else-if="field.type === 'MAP_LOCATION' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <map-location-input v-model="form[field.prop]"></map-location-input>
        </el-form-item>
      </template>

      <!-- 图片position -->
      <template v-else-if="field.type === 'IMG_LOCATION' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <img-location-input
            v-model="form[field.prop]"
            :image-url="field.imageUrl"
          >
          </img-location-input>
        </el-form-item>
      </template>

      <!-- JSON配置 -->
      <template v-else-if="field.type === 'JSON' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <json-schema-input
            v-model="form[field.prop]"
            :schema="field.schema"
            :is-select-key="field.isSelectKey"
          >
          </json-schema-input>
        </el-form-item>
      </template>

      <!-- CONF配置 -->
      <template v-else-if="field.type === 'CONF' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <conf-input
            :ref="field.prop"
            v-model="form[field.prop]"
            :schema="field.schema"
          >
          </conf-input>
        </el-form-item>
      </template>

      <!-- 数采通道选择器 -->
      <template v-else-if="field.type === 'COLLECTOR_CHANNEL_SELECT' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <collector-channel-select
            v-model="form[field.prop]"
            :collectors="field.options"
          >
          </collector-channel-select>
        </el-form-item>
      </template>

      <!-- 数采各通道配置 -->
      <template v-else-if="field.type === 'COLLECTOR_CHANNEL_CONFIG' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <collector-channel-config :disabled="!!field.disabled" v-model="form[field.prop]"></collector-channel-config>
        </el-form-item>
      </template>

      <!-- 数值单位组合输入框 -->
      <template v-else-if="field.type === 'NUMBER_UNIT' && (field.hidden !== true)">
        <el-form-item :label="field.label" :prop="field.prop" :key="field.prop">
          <number-unit-input
            :disabled="!!field.disabled"
            v-model="form[field.prop]"
            :min="field.min === undefined ? -Infinity : field.min"
            :max="field.max === undefined ? Infinity : field.max"
          ></number-unit-input>
        </el-form-item>
      </template>
    </template>
    <!-- Enf Of Fields -->

    <el-form-item>
      <template v-if="formType === 'CREATE'">
        <el-button type="primary" @click="submitCreate">{{$t('common.create')}}</el-button>
      </template>
      <template v-else-if="formType === 'INIT'">
        <el-button type="primary" @click="submitReset">{{$t('common.reset')}}</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="submitUpdate" v-if="submitDisabled === 'true'" disabled="disabled">{{$t('common.update')}}</el-button>
        <el-button type="primary" @click="submitUpdate" v-else>{{$t('common.update')}}</el-button>
      </template>
      <template v-if="formType === 'UPDATEORDELETE'">
        <el-popconfirm
          :title="$t('msg.50')"
          @onConfirm="submitDelete"
        >
          <el-button type="primary" slot="reference"
          >{{$t('common.deleteConfig')}}</el-button>
       </el-popconfirm>
      </template>
    </el-form-item>
  </el-form>
</template>

<script>
import ImageUpload from '@/components/form/ImageUpload';
import MapLocationInput from '@/components/form/MapLocationInput';
import ImgLocationInput from '@/components/form/ImgLocationInput';
import JsonSchemaInput from '@/components/form/JsonSchemaInput';
import ConfInput from '@/components/form/ConfInput';
import CollectorChannelSelect from '@/components/form/CollectorChannelSelect';
import CollectorChannelConfig from '@/components/form/CollectorChannelConfig';
import NumberUnitInput from '@/components/form/NumberUnitInput';
import TextTooltip from '@/components/common/TextTooltip';
import { isFunction } from '@/utils';

export default {
  provide() {
    return {
      form: this.form,
      extraParams: this.extraParams(),
    };
  },
  props: {
    formStyle: {
      type: String,
      validator(value) {
        return ['MODAL_FORM', 'PAGE_FORM'].indexOf(value) !== -1;
      },
    },
    formType: {
      type: String,
      validator(value) {
        return ['CREATE', 'UPDATE', 'UPDATEORDELETE', 'INIT'].indexOf(value) !== -1;
      },
    },
    formTarget: Object,

    // [{ prop, label, type, options?, defaultValue?, rule?, placeholder? }]
    formFields: Array,

    // 额外ID参数回调函数
    extraParams: {
      type: Function,
      default() {
        return () => ({});
      },
    },
    createAction: {
      type: String,
    },
    submitDisabled: {
      type: String,
      default() {
        return 'false';
      },
      required: false,
    },
    submitFlash: {
      type: String,
      default() {
        return 'false';
      },
      required: false,
    },
    submitHidden: {
      type: String,
      default() {
        return 'false';
      },
      required: false,
    },
    createFuntion: {
      type: Function,
      required: false,
    },
    initAction: {
      type: String,
    },
    initFuntion: {
      type: Function,
      required: false,
    },
    updateAction: {
      type: String,
    },
    updateFuntion: {
      type: Function,
      required: false,
    },
    formDisabled: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: '150px',
    },
    // 提交成功提示
    withSuccessMessage: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    TextTooltip,
    MapLocationInput,
    ImgLocationInput,
    JsonSchemaInput,
    ConfInput,
    ImageUpload,
    CollectorChannelSelect,
    CollectorChannelConfig,
    NumberUnitInput,
  },
  data() {
    return {
      form: {},
      rules: {},
      inSubmit: false,
      visible: false,
      verification: {
        data: {
        },
        field: '',
        msg: '',
        msg2: '',
        open: false,
      },
      upResName: '',
    };
  },
  computed: {
    labelPosition() {
      return this.formStyle === 'MODAL_FORM' ? 'top' : 'right';
    },
  },
  watch: {
    formFields: {
      handler() {
        this.initForm();
      },
      deep: true,
    },
    formTarget() {
      this.setForm();
    },
  },
  created() {
    this.initForm();
  },
  mounted() {
    this.setForm();
  },
  methods: {
    treeToList(treeOptions, list) {
      let listT = list;
      for (let i = 0; i < treeOptions.length; i += 1) {
        const treeOption = treeOptions[i];
        list.push(treeOption);
        if (treeOption.children) {
          listT = this.treeToList(treeOption.children, listT);
        }
      }
      return listT;
    },
    loadupResName(id, options) {
      //console.log(id);
      //console.log(options);
      const treeToList1 = this.treeToList(options, []);
      //console.log(treeToList1);
      this.form.fatherId = id;
      treeToList1.forEach((ves) => {
        if (ves.id === id) {
          this.upResName = ves.name;
        }
      });
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      // this.$refs.selectUpResId[0].blur();
    },
    handleNodeClick(data) {
      this.upResName = data.name;
      this.form.fatherId = data.id;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.selectUpResId[0].blur();
    },
    initForm() {
      this.formFields.forEach((item) => {
        const { prop, defaultValue, rule } = item;

        // 表单域及初值，用户已填值 !== undefined 不能覆盖
        if (this.form[prop] === undefined) {
          this.$set(this.form, prop, defaultValue);
        }
        // 校验规则
        this.$set(this.rules, prop, rule);
      });
    },
    // 编辑表单场景下调用
    setForm() {
      if (!this.formTarget) {
        this.$refs.form.resetFields();
        return;
      }
      this.formFields.forEach((item) => {
        const { prop } = item;
        this.form[prop] = this.formTarget[prop];
      });
    },
    submitCreate() {
      // 防止重复提交
      if (this.inSubmit) return;

      if (this.form.endInitFormDelete !== undefined) {
        delete this.form.endInitFormDelete;
      }

      // 表单校验
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.inSubmit = false;
          return;
        }
        this.inSubmit = true;
        if (this.createAction) {
          this.$store.dispatch(this.createAction, {
            ...this.form,
            ...this.extraParams(),
          })
            .then((item) => {
              this.withSuccessMessage && this.$message.success(this.$t('common.success'));
              this.$refs.form.resetFields();
              this.emitDone({ action: 'CREATE', item });
            })
            .catch((err) => {
              console.warn('BASEFORM SUBMIT', err);
            })
            .finally(() => {
              this.inSubmit = false;
              if (this.submitFlash === 'true') {
                window.location.reload();
              }
            });
        } else if (isFunction(this.createFuntion)) {
          this.$emit('createFuntion', {
            ...this.form,
          });
          this.withSuccessMessage && this.$message.success(this.$t('common.success'));
          this.$refs.form.resetFields();
          this.emitDone({ action: 'CREATE', ...this.form });
          this.inSubmit = false;
        } else {
          this.inSubmit = false;
        }
      });
    },
    submitReset() {
      // 防止重复提交
      if (this.inSubmit) return;

      if (this.form.endInitFormDelete !== undefined) {
        delete this.form.endInitFormDelete;
      }

      // 表单校验
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.inSubmit = false;
          return;
        }
        this.inSubmit = true;
        if (this.initAction) {
          this.$store.dispatch(this.initAction, {
            ...this.form,
            ...this.extraParams(),
          })
            .then((item) => {
              this.withSuccessMessage && this.$message.success(this.$t('common.success'));
              this.$refs.form.resetFields();
              this.emitDone({ action: 'INIT', item });
            })
            .catch((err) => {
              console.warn('BASEFORM SUBMIT', err);
            })
            .finally(() => {
              this.inSubmit = false;
              if (this.submitFlash === 'true') {
                window.location.reload();
              }
            });
        } else if (isFunction(this.initFuntion)) {
          this.$emit('initFuntion', {
            ...this.form,
          });
          this.withSuccessMessage && this.$message.success(this.$t('common.success'));
          this.$refs.form.resetFields();
          this.emitDone({ action: 'INIT', ...this.form });
          this.inSubmit = false;
        } else {
          this.inSubmit = false;
        }
      });
    },
    // 验证子组件
    async validateComponents() {
      const props = this.formFields.map(item => item.prop);
      for (let i = 0; i < props.length; i += 1) {
        const prop = props[i];
        if (this.$refs[prop] && this.$refs[prop][0] && this.$refs[prop][0].validate) {
          // TODO 可用Promise.all
          // eslint-disable-next-line no-await-in-loop
          const valid = await this.$refs[prop][0].validate();
          if (!valid) {
            return false;
          }
        }
      }
      return true;
    },
    submitUpdate() {
      // 防止重复提交
      if (this.inSubmit) return;

      if (this.form.endInitFormDelete !== undefined) {
        delete this.form.endInitFormDelete;
      }
      // ADM 推送配置 特殊校验
      if (this.verification.open) {
        const formData = this.form[this.verification.field].split(',');
        const nodeData = this.verification.data.split(',');
        if (formData.length !== nodeData.length) {
          this.inSubmit = false;
          this.$message.error(this.verification.msg);
          return;
        }
        for (let i = 0; i < formData.length; i++) {
          if (formData[i].trim().length === 0) {
            this.inSubmit = false;
            this.$message.error(this.verification.msg2);
            return;
          }
        }
        if ((new Set(formData)).size !== formData.length) {
          this.inSubmit = false;
          this.$message.error(this.verification.msg2);
          return;
        }
      }

      // 表单校验
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.inSubmit = false;
          return;
        }

        // 校验子组件中的表单
        const subValid = await this.validateComponents();
        if (!subValid) {
          this.inSubmit = false;
          return;
        }

        this.inSubmit = true;
        if (this.updateAction) {
          this.$store.dispatch(this.updateAction, {
            ...this.form,
            ...this.extraParams(),
          })
            .then((item) => {
              this.withSuccessMessage && this.$message.success(this.$t('common.success'));
              this.emitDone({ action: 'UPDATE', item });
            })
            .catch((err) => {
              console.warn('BASEFORM SUBMIT', err);
            })
            .finally(() => {
              this.inSubmit = false;
              if (this.submitFlash === 'true') {
                window.location.reload();
              }
            });
        } else if (isFunction(this.updateFuntion)) {
          this.$emit('updateFuntion', {
            ...this.form,
          });
          this.withSuccessMessage && this.$message.success(this.$t('common.success'));
          this.$refs.form.resetFields();
          this.emitDone({ action: 'CREATE', ...this.form });
          this.inSubmit = false;
        } else {
          this.inSubmit = false;
        }
      });
    },
    submitDelete() {
      // 防止重复提交
      if (this.inSubmit) return;
      this.inSubmit = true;
      let baseId = '';
      // eslint-disable-next-line no-return-assign
      Object.keys(this.form).forEach((key) => {
        if (key === 'BaseStation') {
          baseId = this.form[key];
        }
        const type = typeof this.form[key];
        if (type === 'number') {
          this.form[key] = 0;
        } else if (type === 'boolean') {
          this.form[key] = false;
        } else if (type === 'string') {
          this.form[key] = '';
        } else if (type === 'object') {
          this.form[key] = null;
        } else {
          this.formp[key] = undefined;
        }
      });
      const payload = {
        ...this.form,
        ...this.extraParams(),
        isDelete: true,
        baseId,
      };
      this.$store.dispatch(this.updateAction, payload).then((item) => {
        this.withSuccessMessage && this.$message.success(this.$t('common.success'));
        this.emitDone({ action: 'UPDATE', item });
      }).catch((err) => {
        console.warn('BASEFORM SUBMIT', err);
      }).finally(() => {
        this.inSubmit = false;
        // 暂时用来刷新
        if (this.submitFlash === 'true') {
          window.location.reload();
        }
      });
    },
    emitDone(params) {
      this.$emit('done', params);
    },
    nothing() {},

    // 预留父组件调用接口
    setValue(prop, value) {
      this.$set(this.form, prop, value);
    },
    getValue(prop) {
      return this.form[prop];
    },
    // 预留父组件调用接口
    setHidden(prop, boolean) {
      this.formFields.forEach((item) => {
        const { prop: pp } = item;
        if (prop === pp) {
          item.hidden = boolean;
        }
      });
    },
    setDisabled(prop, boolean) {
      this.formFields.forEach((item) => {
        const { prop: pp } = item;
        if (prop === pp) {
          item.disabled = boolean;
        }
      });
    },
    setVerification(prop, data, msg, msg2, open) {
      this.verification.data = data;
      this.verification.field = prop;
      this.verification.msg = msg;
      this.verification.msg2 = msg2;
      this.verification.open = open;
    },
    // 预留父组件调用接口
    initChangeHandler(prop) {
      this.formFields.forEach((item) => {
        const { prop: pp } = item;
        if (prop === pp) {
          const val = this.form[prop];
          const changeHandler = item.changeHandler;
          changeHandler(val);
        }
      });
    },
  },
};
</script>
